import { render, staticRenderFns } from "./OrderOnline.vue?vue&type=template&id=212ca247&"
import script from "./OrderOnline.vue?vue&type=script&lang=js&"
export * from "./OrderOnline.vue?vue&type=script&lang=js&"
import style0 from "./OrderOnline.vue?vue&type=style&index=0&id=212ca247&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports